import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ActiveSessionService } from '@shared/services/active-session.service';
import { AuthFirebaseService } from '@shared/services/auth-firebase.service';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';

@Component({
    selector: 'astrea-active-session',
    templateUrl: './active-session.component.html',
    styleUrls: ['./active-session.component.scss'],
    standalone: false
})
export class ActiveSessionComponent implements OnInit {

  public redirect = '/searcher';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private seo: SeoMetadataService,
    private authFirebaseService: AuthFirebaseService,
    private activeSessionService: ActiveSessionService,
  ) { }

  ngOnInit(): void {
    this.setMetadata();
    this.route.queryParams
      .subscribe({
        next: (params: Params) => {
          if (params.bookcode) this.redirect = `reader/${params.bookcode}`;
        }
      });
  }

  setMetadata(): void {
    this.seo.setMetadata({
      title: 'Sesión activa',
      description: 'Sesión activa en otro dispositivo.',
      relativeUrl: '/active-session',
      shouldIndex: false,
    });
  }

  logoutSessions(): void {
    this.activeSessionService.closeAllSessions()
      .subscribe({
        next: res => {
          this.authFirebaseService.logout();
          setTimeout(() => {
            this.router.navigate([this.redirect]);
          }, 500);
        }
      })
  }

}
